export default {
      id: "deco_footer-usage",
      viewBox: "0 0 800 1165",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco_footer-usage",
      toString: function () {
        return this.url;
      }
    }